import styled from 'styled-components';

export const StyledAdminWrapper = styled.form`
  display: flex;
`;
export const StyledLabel = styled.p``;
export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  button {
    margin: 5px;
  }
`;
